// extracted by mini-css-extract-plugin
module.exports = {"cta":"MainCta_cta__X271B","cta__background":"MainCta_cta__background__pMZ1u","cta__title":"MainCta_cta__title__9geRG","cta__button":"MainCta_cta__button__TR1BA"};